export default __webpack_public_path__ + "static/media/header.f13daf3c.jpeg";